import { inject, Injectable, Injector } from "@angular/core";
import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest, } from "@angular/common/http";
import { catchError, filter, take } from "rxjs/operators";
import { throwError } from "rxjs";
import { AuthService } from "./auth.service";
import { EReqHeaders } from "./auth.enum";
import { LocalStorage } from "@shared/services/storages/local-storage";
import { ToastService } from "@shared/third-part-modules/toastr/toast.service";
import { Languages } from '@app/core/services/languages.enum';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
  private _authService = inject(AuthService);
  injector = inject(Injector);

  intercept(request: HttpRequest<unknown>, next: HttpHandler) {
    const access_token = LocalStorage.get('access');
    const language: Languages = LocalStorage.get('lang') || Languages.DE;

    let modifiedHeaders = request.headers
      .append(EReqHeaders.LANGUAGE, language)
    if (access_token) {
      modifiedHeaders = modifiedHeaders.append(EReqHeaders.AUTHORIZATION, `Bearer ${access_token}`);
    }
    const modifiedRequest = request.clone({
      headers: modifiedHeaders,
      withCredentials: false, /* TODO fix CORS in backend */
    });
    return next.handle(modifiedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        const _toastService = this.injector.get(ToastService);
        if (error.status === 500) {
          _toastService.error("VALIDATION_MESSAGES.SERVER_ERROR");
        }
        if (error.status === 401) {
            this._authService.logout();
        }
        if (error.status === 403) {
          _toastService.error("VALIDATION_MESSAGES.ACCESS_DENIED");
        }
        return throwError(() => error);
      })
    );
  }

  private addTokenHeader(request: HttpRequest<any>, token: string) {
    return request.clone({ headers: request.headers.set(EReqHeaders.AUTHORIZATION, `Bearer ${token}`) });
  }
}
